function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from "react";
import { FaFacebook, FaLink, FaLinkedin, FaYoutube, FaFlickr, FaInstagram } from "react-icons/fa";
import { RiTwitterXFill } from "react-icons/ri";
var PlatformIcons = {
    fb: FaFacebook,
    tw: RiTwitterXFill,
    lin: FaLinkedin,
    yt: FaYoutube,
    insta: FaInstagram,
    flckr: FaFlickr,
    none: FaLink
};
export default function PlatformIcon(_param) {
    var type = _param.type, props = _object_without_properties(_param, [
        "type"
    ]);
    var Icon = PlatformIcons[type];
    return /*#__PURE__*/ React.createElement(Icon, props);
}

//# sourceMappingURL=PlatformIcon.js.map